<template>
  <div class="container">
    <div class="content">
      <el-form
        size="mini"
        ref="form"
        :model="searchInfo"
        label-width="80px"
        label-position="right"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="结业时间:">
              <common-date-range-selector
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                clearable
                v-model="searchInfo.date"
                @change="handleSearch"
                :picker-options="effectiveDate"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学员:" prop="key_word">
              <el-input
                v-model="searchInfo.key_word"
                placeholder="学员姓名/手机号"
                @change="handleSearch"
                prefix-icon="el-icon-search"
                clearable
                maxlength="99"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="课程顾问:" prop="follow_staff_id">
              <el-select
                v-model="searchInfo.follow_staff_id"
                multiple
                clearable
                @focus="handleChangeFollowStaff('')"
                filterable
                @change="handleSearch"
                placeholder="请选择"
                :filter-method="handleChangeFollowStaff"
              >
                <el-option
                  v-for="item in followStaffList"
                  :key="item.staff_id"
                  :label="item.name"
                  :value="item.staff_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="课程老师:">
              <common-staff-pull-down
                :originId.sync="searchInfo.relation_teacher_id"
                :defaultSelected.sync="searchInfo.class_teacher_list"
                :jobIds="[1]"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="首次入学时间:">
              <common-date-range-selector
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                clearable
                v-model="searchInfo.transform_time"
                @change="handleSearch"
                :picker-options="effectiveDate"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结业分类:" prop="completion_category_id">
              <el-select
                v-model="searchInfo.completion_category_id"
                multiple
                clearable
                placeholder="请选择"
                @change="handleSearch"
              >
                <el-option label="距离远" :value="1"></el-option>
                <el-option label="不感兴趣" :value="2"></el-option>
                <el-option label="价格贵" :value="3"></el-option>
                <el-option label="时间不合适" :value="4"></el-option>
                <el-option label="艺考" :value="5"></el-option>
                <el-option label="学业忙/工作忙" :value="6"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="结业原因:" prop="completion_remark">
              <el-input
                v-model="searchInfo.completion_remark"
                placeholder="请输入关键词"
                @change="handleSearch"
                prefix-icon="el-icon-search"
                clearable
                maxlength="99"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        v-horizontal-scroll
        :data="tableData"
        stripe
        style="width: 100%"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        @sort-change="clickStort"
      >
        <el-table-column
          label="序号"
          prop="serialNumber"
          width="50"
        ></el-table-column>
        <el-table-column
          label="结业时间"
          prop="create_time"
          sortable="custom"
          width="100"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot-scope="scope">
            {{ scope.row.completion.create_time }}
          </template>
        </el-table-column>
        <el-table-column label="学员姓名" prop="name">
          <template slot-scope="scope">
            <div
              class="mwow-green studentName"
              @click="goStudentDetail(scope.row)"
            >
              {{ scope.row.name ? scope.row.name : "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="goods_name" width="150">
          <template slot-scope="scope">
            {{ "+" + scope.row.area_code }} {{ scope.row.mobile || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="性别" prop="sex" width="70">
          <template slot-scope="scope">
            <div v-if="scope.row.sex === 0">未知</div>
            <div v-if="scope.row.sex === 1">男</div>
            <div v-if="scope.row.sex === 2">女</div>
          </template>
        </el-table-column>
        <el-table-column label="年龄" prop="age"></el-table-column>
        <el-table-column label="课程顾问" prop="follow_staff.name">
          <template slot-scope="scope">
            {{ scope.row.follow_staff ? scope.row.follow_staff.name : "-" }}
          </template>
        </el-table-column>
        <el-table-column label="课程老师">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.relation_teacher_list
                  ? scope.row.relation_teacher_list
                      .map((it) => {
                        return it.name;
                      })
                      .join("、") || "-"
                  : "-"
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="用户意向" prop="intent">
          <template slot-scope="scope">
            {{ followLatentObj[scope.row.completion.intent] || "-" }}
          </template>
        </el-table-column>
        <!-- 此页面读取 completion 下的 category_id -->
        <el-table-column label="结业分类">
          <template slot-scope="scope">
            <div v-if="scope.row.completion.completion_category_id === 1">
              距离远
            </div>
            <div v-if="scope.row.completion.completion_category_id === 2">
              不感兴趣
            </div>
            <div v-if="scope.row.completion.completion_category_id === 3">
              价格贵
            </div>
            <div v-if="scope.row.completion.completion_category_id === 4">
              时间不合适
            </div>
            <div v-if="scope.row.completion.completion_category_id === 5">
              艺考
            </div>
            <div v-if="scope.row.completion.completion_category_id === 6">
              学业忙/工作忙
            </div>
          </template>
        </el-table-column>
        <el-table-column label="结业原因" prop="intent" width="280">
          <template slot-scope="scope">
            <div v-if="scope.row.completion.completion_remark.length <= 20">
              {{ scope.row.completion.completion_remark || "-" }}
            </div>
            <el-popover
              v-else
              placement="top"
              width="200"
              trigger="hover"
              :content="`${scope.row.completion.completion_remark}`"
            >
              <div slot="reference" class="extend">
                {{ scope.row.completion.completion_remark || "-" }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="首次入学时间"
          prop="transform_time"
          sortable="custom"
          width="150"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot-scope="scope">
            {{ scope.row.completion.transform_time }}
          </template>
        </el-table-column>
        <el-table-column
          label="最近入学时间"
          prop="latest_transform_time"
          sortable="custom"
          width="150"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot-scope="scope">
            {{ scope.row.completion.latest_transform_time }}
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="staff.name"> </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-size="pageSize"
        :page-sizes="pageSizeArray"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @current-change="handlePagerChange"
        @size-change="handlePagerSizeChange"
        :style="{ float: 'right', padding: '17px' }"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { staffList } from "@/api/globalSearch";
import { studentCompletionListApi } from "@/api/statistics";
import { dateFormat } from "@/utils/timeFormat";
import { getFollowLatentApi } from "@/api/studentFollow";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

export default {
  components: {
    commonStaffPullDown,
    commonDateRangeSelector,
  },
  props: ["visible"],
  data() {
    return {
      searchInfo: {
        date: [],
        key_word: "",
        completion_category_id: [],
        follow_staff_id: [],
        completion_remark: "",
        sort_field: "create_time",
        sort_type: "desc",
      },
      followStaffList: [],
      tableData: [],
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      page: 1,
      followLatentObj: {},
      // 未来时间应不可选
      effectiveDate: {
        disabledDate(date) {
          return date.getTime() > Date.now();
        },
      },
    };
  },

  created() {
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.init();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.init();
    }
  },
  methods: {
    init() {
      this.getList({
        page: 1,
        page_size: 10,
      });
      getFollowLatentApi().then((res) => {
        const obj = {};
        res.data.list.map((item) => {
          obj[item.key] = item.value;
        });
        this.followLatentObj = obj;
      });
    },
    solveSearchInfo(option) {
      let data = { ...option };
      if (this.searchInfo.date && this.searchInfo.date.length > 0) {
        data.start_date = this.searchInfo.date[0];
        data.end_date = this.searchInfo.date[1];
      }
      if (
        this.searchInfo.transform_time &&
        this.searchInfo.transform_time.length > 0
      ) {
        data.transform_start_date = this.searchInfo.transform_time[0];
        data.transform_end_date = this.searchInfo.transform_time[1];
      }
      if (
        this.searchInfo.completion_category_id &&
        this.searchInfo.completion_category_id.length > 0
      ) {
        data.completion_category_ids = this.searchInfo.completion_category_id;
      }
      if (
        this.searchInfo.follow_staff_id &&
        this.searchInfo.follow_staff_id.length > 0
      ) {
        data.follow_staff_ids = this.searchInfo.follow_staff_id;
      }
      if (this.searchInfo.key_word) {
        data.key_word = this.searchInfo.key_word;
      }
      if (this.searchInfo.completion_remark) {
        data.completion_remark = this.searchInfo.completion_remark;
      }
      if (this.searchInfo.sort_field) {
        data.sort_field = this.searchInfo.sort_field;
      }
      if (this.searchInfo.sort_type) {
        data.sort_type = this.searchInfo.sort_type;
      }
      if (this.searchInfo.relation_teacher_id) {
        data.relation_teacher_id = this.searchInfo.relation_teacher_id;
      }
      return data;
    },

    getList(option) {
      let data = this.solveSearchInfo(option);
      data.type = 1;
      studentCompletionListApi(data).then((res) => {
        if (res.error_code === 0) {
          let serialNumber = 0;
          res.data.list.map((item) => {
            serialNumber++;
            item.serialNumber = serialNumber;
            // 结业时间
            item.completion.create_time = dateFormat(
              "YYYY-mm-dd",
              item.completion.create_time * 1000
            );
            // 首次入学时间
            item.completion.transform_time = dateFormat(
              "YYYY-mm-dd",
              item.completion.transform_time * 1000
            );
            // 最近入学时间
            item.completion.latest_transform_time = dateFormat(
              "YYYY-mm-dd",
              item.completion.latest_transform_time * 1000
            );
          });
          this.tableData = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleChangeFollowStaff(v) {
      staffList({
        page: 1,
        page_size: 50,
        key_word: v,
        job_ids: [3],
      }).then((res) => {
        this.followStaffList = res.data.list;
      });
    },
    handleSelectionChange(arr) {
      console.log(arr);
    },
    // 排序
    clickStort(e) {
      this.searchInfo.sort_field = e.prop;
      // 如果排序字段是结业时间，参数名称替换为 create_time
      if (e.prop === "completion_time") {
        this.searchInfo.sort_field = "create_time";
      }
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    // 去到学员详情
    goStudentDetail(row) {
      this.$router.push({
        name: "studyDetails",
        query: {
          id: row.student_id,
          from: "graduationRecord",
        },
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    handleBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  background-color: #ffffff;
  border-radius: 4px;
  overflow: hidden;
}
/deep/ .buttons {
  position: relative;
  right: 8px;
}
/deep/ .el-form {
  .el-form-item {
    width: 100%;
    display: flex;
    .el-form-item__label {
      min-width: 88px;
      text-align: right;
    }
    .el-form-item__content {
      margin-right: 58px;
      margin-left: 0 !important;
      width: 100%;
      flex: 1;
      .inputBox {
        display: flex;
        position: relative;
        &:hover {
          .clear-icon {
            display: block;
          }
        }
        .clear-icon {
          position: absolute;
          top: 8px;
          right: 0;
          font-size: 14px;
          color: #d8d8d8;
          cursor: pointer;
          display: none;
        }
        .el-input {
          width: auto;
          text-align: center;
        }
      }
    }
    .el-select {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
  }
}

.extend {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  word-wrap: break-word;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
